import {DOCUMENT, isPlatformBrowser} from '@angular/common';
import {Directive, ElementRef, HostListener, Inject, PLATFORM_ID} from '@angular/core';

@Directive({
  selector: '[webuSharedNavScroll], [webu-shared-nav-scroll]'
})
export class SharedNavScrollDirective {

  constructor(@Inject(DOCUMENT) private document: Document, private elRef: ElementRef, @Inject(PLATFORM_ID) private platformId: any) {}

  prevScrollpos = window.scrollY;

  @HostListener('window: scroll', ['event'])
  onScrollEvent() {
    if (isPlatformBrowser(this.platformId)) {
      // global nav
      const gbNav = this.document.getElementById('gbGlobalNav');
      gbNav?.setAttribute('style', 'transition: 0.35s ease');
      gbNav?.setAttribute('sticky', 'true');
      let gbNavHeight = gbNav?.offsetHeight;
      const gbNavLength = gbNav?.classList.length;

      // shared nav
      const nav = this.elRef.nativeElement.parentNode.querySelector('#gbSharedNav');

      // sticking pricing
      const stickyPricing = this.elRef.nativeElement.parentNode.querySelector('#appStickyPricing');
      const stickyError = this.elRef.nativeElement.parentNode.querySelector('#appStickyError');

      // sticky error message
      const stickyErrorMessage = this.elRef.nativeElement.parentNode.querySelector('#appStickyError');

      const currentScrollPos = window.scrollY;

      if(nav && gbNav) {
        if (this.prevScrollpos > currentScrollPos) {
          if (gbNavLength && gbNavHeight) {
            gbNavHeight = gbNavHeight - 1;
            nav.style.top = gbNavHeight + 'px';
            gbNav.style.top = '0';
            const navHeight = nav?.offsetHeight;
            stickyPricing ? stickyPricing.style.top =  navHeight + gbNavHeight + 'px' : '';
            stickyErrorMessage ? stickyErrorMessage.style.top =  navHeight + gbNavHeight + 'px' : '';
            stickyError ? stickyError.style.top =  navHeight + gbNavHeight + 'px' : '';
          }
        } else {
          stickyPricing ? stickyPricing.style.top = '0' : '';
          stickyError ? stickyError.style.top =  '0' : '';
          nav.style.top = '-50px';
          gbNav.style.top = '-100px';
        }
      }
      this.prevScrollpos = currentScrollPos;
    }
  }
}
